import { CardFooterLinks } from '../../../components/molecules/Card/CardFooter';
import { mediaDir } from '../../../appolloConfig';
import { AllPedagogiesAndTypesQuery } from '../../../graphql/generated/graphql';
import {
  PedagogiesContent,
  PedagogiesType
} from '../../../types/pedagogies/pedagogies.def';
import { getRessourceTypeInfo } from '../../../theme/ressourceTypeInfo';

export const getPedagogieCardLinks = (
  entry: Omit<PedagogiesContent, 'reservedToProf' | 'pedagogie_type' | 'id'>
): CardFooterLinks[] => {
  const links: CardFooterLinks[] =
    (entry?.ressources &&
      entry?.ressources?.map(m => ({
        href: m.lien ?? (m.media && mediaDir + m.media[0]?.url),
        icon: getRessourceTypeInfo(m.type.nom).icon,
        text: m.titre,
        color: getRessourceTypeInfo(m.type.nom).color,
        variant: 'ressource'
      }))) ||
    [];
  return [...links];
};

export const getPedagogiesTypesFromQuery: (
  pedagogiesType: AllPedagogiesAndTypesQuery['findPedagogieTypeWithRelatedPedagogies']
) => PedagogiesType[] = pedagogiesType => {
  if (!pedagogiesType || pedagogiesType.length < 1) return [];
  return pedagogiesType.map(p => ({
    id: p.id,
    name: p.name
  }));
};
